import * as yup from 'yup';

export const TagValidationSchema = yup.object().shape({
	name: yup.string().required('Nazwa jest wymagana')
});
